module.exports = __webpack_public_path__ + "img/articleBabyBlue.c4f51f2c.png";